import { render, staticRenderFns } from "./DocName.vue?vue&type=template&id=d7fbb178&scoped=true&lang=pug"
import script from "./DocName.vue?vue&type=script&lang=js"
export * from "./DocName.vue?vue&type=script&lang=js"
import style0 from "./DocName.vue?vue&type=style&index=0&id=d7fbb178&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fbb178",
  null
  
)

export default component.exports